export const initDesktopNav = () => {
  const navRoot = document.querySelector('.main-navigation');
  if (!navRoot || window.innerWidth < 1024) return;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const submenuTriggers = navRoot.querySelectorAll('[data-submenu-trigger]');
  const ESCAPE = 'Escape';

  submenuTriggers.forEach(trigger => {
    const parent = trigger.closest('li');
    const submenu = parent?.querySelector('.sub-menu');
    if (!submenu) return;

    submenu.setAttribute('aria-hidden', 'true');
    trigger.setAttribute('aria-expanded', 'false');

    parent.addEventListener('mouseenter', () => {
      submenu.classList.add('is-visible');
      submenu.setAttribute('aria-hidden', 'false');
      trigger.setAttribute('aria-expanded', 'true');
      if (!prefersReducedMotion) {
        submenu.style.opacity = '0';
        submenu.style.transition = 'opacity 0.2s ease';
        requestAnimationFrame(() => submenu.style.opacity = '1');
      }
    });

    parent.addEventListener('mouseleave', () => {
      submenu.classList.remove('is-visible');
      submenu.setAttribute('aria-hidden', 'true');
      trigger.setAttribute('aria-expanded', 'false');
      if (!prefersReducedMotion) {
        submenu.style.opacity = '0';
        submenu.style.transition = 'opacity 0.2s ease';
        submenu.addEventListener('transitionend', () => submenu.removeAttribute('style'), { once: true });
      } else {
        submenu.removeAttribute('style');
      }
    });

    parent.addEventListener('focusin', () => {
      submenu.classList.add('is-visible');
      submenu.setAttribute('aria-hidden', 'false');
      trigger.setAttribute('aria-expanded', 'true');
    });

    parent.addEventListener('focusout', (e) => {
      if (!parent.contains(e.relatedTarget)) {
        submenu.classList.remove('is-visible');
        submenu.setAttribute('aria-hidden', 'true');
        trigger.setAttribute('aria-expanded', 'false');
        submenu.removeAttribute('style');
      }
    });

    trigger.addEventListener('keydown', (e) => {
      if (e.key === ESCAPE) {
        submenu.classList.remove('is-visible');
        submenu.setAttribute('aria-hidden', 'true');
        trigger.setAttribute('aria-expanded', 'false');
        trigger.focus();
      }
    });

    const submenuLinks = submenu.querySelectorAll('a');
    if (submenuLinks.length) {
      submenuLinks[submenuLinks.length - 1].addEventListener('keydown', (e) => {
        if (e.key === 'Tab' && !e.shiftKey) {
          e.preventDefault();
          trigger.focus();
        }
      });
    }
  });
};
